import script from "./textItemBox.vue?vue&type=script&setup=true&lang=js"
export * from "./textItemBox.vue?vue&type=script&setup=true&lang=js"

import "./textItemBox.vue?vue&type=style&index=0&id=796d1dae&lang=less&scoped=true"

import exportComponent from "C:\\Users\\11920\\Desktop\\vue_db\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-796d1dae"]])

export default __exports__